import { Text3, IconWarningRegular, Stack, skinVars, useDialog } from '@telefonica/mistica';
import { AxiosError } from 'axios';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import OTPVerification from '../../../../../components/OTPVerification';
import { sendContactVerificationOTP, validateContactVerificationOTP } from '../../../../../services/CustomerService';
import { setInfoError } from '../../../../../utils/dataTransformation/errorMesssages';
import './index.scss';
import { isWebviewAndroid, isWebviewIOS } from '../../../../../utils/navigation/controlDevices';
import { TrackingEvents } from '../../../../../utils/dataTransformation/tracking';
import {
    hideMobileCharacters,
    formatMobileNumber,
    hideEmailCharacters,
} from '../../../../../utils/dataTransformation/unitsConversion';
import HeaderProfile from '../../../../../components/HeaderProfile';

export const ContactsValidate: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { trackingScreenView } = new TrackingEvents();
    const [params] = useSearchParams();
    const contact: any = params.get('contact')!;
    const flow = params.get('flow')!;
    const typeVerificationObd: any = flow;
    const [otp, setOtp] = useState('');
    const [incorrectCode, setIncorrectCode] = useState<boolean>(false);
    const { dialog } = useDialog();

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
    }, []);

    const sendToNative = (url: string, description: string, type: string, err?: any) => {
        const feedbackData = {
            stateFeedback: description,
            err: err,
        };
        const isSuccess = description === 'SUCCESS';
        const queryParams = {
            flow: flow,
            title: isSuccess ? t('contactVerificationSuccessTitle') : err.title,
            subtitle: isSuccess
                ? flow === 'mobile'
                    ? t('descriptionFeedbackSuccesOtpMobile')
                    : t('descriptionFeedbackSuccesOtpEmail')
                : err.localizedDescription,
            state: description,
            errorCode: err ? `${t('codeError')}: #${err.id}` : '',
        };

        navigate(`${url}?otp=${true}&flow=${flow}`, { state: feedbackData });
    };

    const escalationOTPSend = () => {
        sendContactVerificationOTP(contact)
            .then(() => {})
            .catch((error: AxiosError) => {
                sendToNative('/feedback/contacts/validate', 'ERROR', 'feedback-error', setInfoError(error));
            });
    };

    const escalationOTPValidate = () => {
        validateContactVerificationOTP(otp)
            .then((response: any) => {
                if (response.status === 200) {
                    sendToNative('/feedback/contacts/validate', 'SUCCESS', 'feedback-success', '');
                }
            })
            .catch((error: AxiosError) => {
                const { id } = setInfoError(error);
                if ([400, 403].includes(Number(error.response?.status))) {
                    dialog({
                        icon: <IconWarningRegular color={skinVars.colors.feedbackErrorBackground} size={64} />,
                        title: t('profileFeedbackErrorTitle'),
                        message: (() => {
                            return (
                                <Stack space={16}>
                                    <Text3 light color={skinVars.colors.borderHigh}>
                                        {t('errorValidateOTP')}
                                    </Text3>
                                    {id && (
                                        <Text3 light color={skinVars.colors.borderHigh}>
                                            {`${t('codeError')} ${id}`}
                                        </Text3>
                                    )}
                                </Stack>
                            );
                        })() as any,
                        onAccept() {},
                        acceptText: t('buttonUnderstoodFeedback'),
                    });
                } else {
                    sendToNative('/feedback/contacts/validate', 'ERROR', 'feedback-error', setInfoError(error));
                }
            });
    };

    return (
        <div className='ContactsValidate'>
            <HeaderProfile
                title={flow === 'mobile' ? t('personalDataUpdateMobileTitle') : t('personalDataUpdateEmailTitle')}
                breadcrumbs={[
                    { title: t('profileTitle'), url: '/profile' },
                    { title: t('personalDataTitle2'), url: '/profile/personal-data' },
                ]}
            />
            <div className='layaout-content'>
                <OTPVerification
                    title={`${t('updateContactsVerifiedOtp')} ${
                        flow === 'mobile' ? t('descriptionVerifyOtpMobile') : t('updateContactsVerifiedOtpEmail')
                    } ${
                        flow === 'mobile'
                            ? hideMobileCharacters(formatMobileNumber(contact))
                            : hideEmailCharacters(contact)
                    }.`}
                    subtitle1={''}
                    subtitle2={''}
                    contact={''}
                    handleButtonContinue={escalationOTPValidate}
                    handleSendAgain={escalationOTPSend}
                    setOTPValue={setOtp}
                    incorrectCode={incorrectCode}
                    typeVerificationContact={typeVerificationObd}
                ></OTPVerification>
            </div>
        </div>
    );
};

export default ContactsValidate;
